var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-bubble',{attrs:{"isMine":_vm.isMine}},[_c('div',{staticClass:"sound-element-wrapper",attrs:{"title":"单击播放"},on:{"click":_vm.play}},[_c('i',{staticClass:"iconfont icon-voice"}),_vm._v("\r\n    "+_vm._s(_vm.second + '"')+"\r\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }